export default __webpack_public_path__ + "static/media/user.725ff2f0.svg";